module.exports = __webpack_public_path__ + "img/imagen2.536ac2b2.png";